
import { useState } from 'react';
import Button from '../../../components/base/Button';

export default function ContactSection() {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    tipo: '',
    valor: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');
  const [showTipoDropdown, setShowTipoDropdown] = useState(false);
  const [showValorDropdown, setShowValorDropdown] = useState(false);

  const handleWhatsAppSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    // Validar apenas campos obrigatórios
    if (!formData.phone) {
      alert('Por favor, preencha o campo obrigatório (Telefone).');
      return;
    }

    // Criar mensagem formatada para WhatsApp
    let whatsappMessage = `🔔 *Nova Solicitação de Proposta*%0A%0A`;
    
    if (formData.name) whatsappMessage += `👤 *Nome:* ${formData.name}%0A`;
    whatsappMessage += `📱 *Telefone:* ${formData.phone}%0A`;
    if (formData.tipo) whatsappMessage += `⚖️ *Tipo do Precatório:* ${formData.tipo}%0A`;
    if (formData.valor) whatsappMessage += `💰 *Valor:* ${formData.valor}%0A`;
    whatsappMessage += `%0A📝 _Mensagem enviada através do site PrecNacional_`;

    // Abrir WhatsApp com a mensagem
    window.open(`https://wa.me/5531972176645?text=${whatsappMessage}`, '_blank');
    
    // Limpar formulário após envio
    setFormData({ name: '', phone: '', tipo: '', valor: '' });
    
    // Mostrar mensagem de sucesso
    alert('Redirecionando para o WhatsApp com suas informações!');
  };

  const handleEmailSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    // Validar apenas campos obrigatórios
    if (!formData.phone) {
      alert('Por favor, preencha o campo obrigatório (Telefone).');
      return;
    }

    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      const formDataToSend = new FormData();
      formDataToSend.append('name', formData.name);
      formDataToSend.append('phone', formData.phone);
      formDataToSend.append('tipo', formData.tipo);
      formDataToSend.append('valor', formData.valor);

      const response = await fetch('https://readdy.ai/api/form/d3jfg4nuqofrij8380f0', {
        method: 'POST',
        body: formDataToSend
      });

      if (response.ok) {
        setSubmitMessage('Mensagem enviada com sucesso! Entraremos em contato em breve.');
        setFormData({ name: '', phone: '', tipo: '', valor: '' });
      } else {
        setSubmitMessage('Erro ao enviar mensagem. Tente novamente.');
      }
    } catch (error) {
      setSubmitMessage('Erro ao enviar mensagem. Tente novamente.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleTipoSelect = (tipo: string) => {
    setFormData({ ...formData, tipo });
    setShowTipoDropdown(false);
  };

  const handleValorSelect = (valor: string) => {
    setFormData({ ...formData, valor });
    setShowValorDropdown(false);
  };

  return (
    <section id="contato" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
            Solicite sua Proposta
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto" style={{ fontFamily: 'Open Sans, sans-serif' }}>
            Entre em contato conosco e descubra como podemos ajudar você a obter 
            as melhores condições para seus precatórios
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div>
            <h3 className="text-2xl font-semibold text-gray-800 mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
              Fale Conosco
            </h3>
            
            <div className="space-y-6">
              <div className="flex items-center">
                <div className="w-12 h-12 bg-blue-600 text-white rounded-full flex items-center justify-center mr-4">
                  <i className="ri-phone-line text-xl"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-800" style={{ fontFamily: 'Poppins, sans-serif' }}>Telefone</h4>
                  <p className="text-gray-700" style={{ fontFamily: 'Open Sans, sans-serif' }}>(31) 97217-6645</p>
                </div>
              </div>
              
              <div className="flex items-center">
                <div className="w-12 h-12 bg-blue-600 text-white rounded-full flex items-center justify-center mr-4">
                  <i className="ri-mail-line text-xl"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-800" style={{ fontFamily: 'Poppins, sans-serif' }}>E-mail</h4>
                  <p className="text-gray-700" style={{ fontFamily: 'Open Sans, sans-serif' }}>comercial@precnacional.com.br</p>
                </div>
              </div>
              
              <div className="flex items-center">
                <div className="w-12 h-12 bg-blue-600 text-white rounded-full flex items-center justify-center mr-4">
                  <i className="ri-map-pin-line text-xl"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-800" style={{ fontFamily: 'Poppins, sans-serif' }}>Localização</h4>
                  <p className="text-gray-700" style={{ fontFamily: 'Open Sans, sans-serif' }}>Belo Horizonte, MG</p>
                </div>
              </div>
              
              <div className="flex items-center">
                <div className="w-12 h-12 bg-blue-600 text-white rounded-full flex items-center justify-center mr-4">
                  <i className="ri-time-line text-xl"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-800" style={{ fontFamily: 'Poppins, sans-serif' }}>Horário</h4>
                  <p className="text-gray-700" style={{ fontFamily: 'Open Sans, sans-serif' }}>Segunda a Sexta: 8h às 18h</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="bg-white p-8 rounded-xl shadow-lg">
            <form data-readdy-form id="contato-form" className="space-y-6">
              <div>
                <label htmlFor="name" className="flex items-center text-sm font-medium text-gray-800 mb-2">
                  <i className="ri-user-line mr-2 text-blue-600"></i>
                  Nome Completo
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                  placeholder="Digite seu nome completo"
                />
              </div>
              
              <div>
                <label htmlFor="phone" className="flex items-center text-sm font-medium text-gray-800 mb-2">
                  <i className="ri-phone-line mr-2 text-blue-600"></i>
                  Telefone *
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                  placeholder="(00) 00000-0000"
                  required
                />
              </div>

              <div className="relative">
                <label className="flex items-center text-sm font-medium text-gray-800 mb-2">
                  <i className="ri-government-line mr-2 text-blue-600"></i>
                  Tipo do Precatório
                </label>
                <button
                  type="button"
                  onClick={() => setShowTipoDropdown(!showTipoDropdown)}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm text-left bg-white flex items-center justify-between"
                >
                  <span className={formData.tipo ? 'text-gray-900' : 'text-gray-500'}>
                    {formData.tipo || 'Selecione o tipo do precatório'}
                  </span>
                  <i className={`ri-arrow-down-s-line transition-transform ${showTipoDropdown ? 'rotate-180' : ''}`}></i>
                </button>
                {showTipoDropdown && (
                  <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg">
                    <button
                      type="button"
                      onClick={() => handleTipoSelect('Federal')}
                      className="w-full px-4 py-3 text-left hover:bg-gray-50 text-sm border-b border-gray-100"
                    >
                      Federal
                    </button>
                    <button
                      type="button"
                      onClick={() => handleTipoSelect('Estadual')}
                      className="w-full px-4 py-3 text-left hover:bg-gray-50 text-sm"
                    >
                      Estadual
                    </button>
                  </div>
                )}
              </div>

              <div className="relative">
                <label className="flex items-center text-sm font-medium text-gray-800 mb-2">
                  <i className="ri-money-dollar-circle-line mr-2 text-blue-600"></i>
                  Valor do Precatório
                </label>
                <button
                  type="button"
                  onClick={() => setShowValorDropdown(!showValorDropdown)}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm text-left bg-white flex items-center justify-between"
                >
                  <span className={formData.valor ? 'text-gray-900' : 'text-gray-500'}>
                    {formData.valor || 'Selecione a faixa de valor'}
                  </span>
                  <i className={`ri-arrow-down-s-line transition-transform ${showValorDropdown ? 'rotate-180' : ''}`}></i>
                </button>
                {showValorDropdown && (
                  <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg">
                    <button
                      type="button"
                      onClick={() => handleValorSelect('Abaixo de R$ 100.000')}
                      className="w-full px-4 py-3 text-left hover:bg-gray-50 text-sm border-b border-gray-100"
                    >
                      Abaixo de R$ 100.000
                    </button>
                    <button
                      type="button"
                      onClick={() => handleValorSelect('Acima de R$ 100.000')}
                      className="w-full px-4 py-3 text-left hover:bg-gray-50 text-sm"
                    >
                      Acima de R$ 100.000
                    </button>
                  </div>
                )}
              </div>
              
              {submitMessage && (
                <div className={`px-4 py-3 rounded-lg ${
                  submitMessage.includes('sucesso') 
                    ? 'bg-green-50 border border-green-200 text-green-700' 
                    : 'bg-red-50 border border-red-200 text-red-700'
                }`}>
                  <span className="text-sm">{submitMessage}</span>
                </div>
              )}
              
              <div className="bg-blue-50 border border-blue-200 text-blue-700 px-4 py-3 rounded-lg">
                <div className="flex items-center">
                  <i className="ri-information-line mr-2 text-lg"></i>
                  <span className="text-sm">
                    Escolha como deseja enviar sua mensagem:
                  </span>
                </div>
              </div>
              
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <Button 
                  type="button"
                  onClick={handleWhatsAppSubmit}
                  size="lg" 
                  className="w-full bg-green-600 hover:bg-green-700 text-white whitespace-nowrap"
                >
                  <i className="ri-whatsapp-line mr-2"></i>
                  Enviar via WhatsApp
                </Button>
                
                <Button 
                  type="button"
                  onClick={handleEmailSubmit}
                  size="lg" 
                  className="w-full bg-blue-600 hover:bg-blue-700 text-white whitespace-nowrap"
                  disabled={isSubmitting}
                >
                  <i className="ri-mail-line mr-2"></i>
                  {isSubmitting ? 'Enviando...' : 'Enviar por Email'}
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
